(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nn-related-variants"] && !Shopify.designMode) return;
  try {
    (() => {
    const cache = window.NNRelatedVariantsCache || (window.NNRelatedVariantsCache = new Map());
    const query = `query RelatedVariants($query: String!, $cursor: String) { products(first: 250, after: $cursor, query: $query) { edges { cursor node { id handle title shortTitle: metafield(namespace: "custom", key: "short_title") { value } availableForSale featuredImage { url(transform: { maxWidth: 400, maxHeight: 400, crop: CENTER }) altText } variants(first: 10) { nodes { id availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } } } } } pageInfo { hasNextPage } } }`;
    const escapeHtml = (value) => String(value || '').replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
    const numericId = (id) => String(id || '').split('/').pop();

    class RelatedVariants extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.imageView = this.querySelector('[data-va-image-view]');
        this.imageGrid = this.querySelector('[data-va-image-grid]');
        this.trigger = this.querySelector('[data-va-open]');
        this.previews = this.querySelector('[data-va-previews]');
        this.triggerText = this.querySelector('[data-va-trigger-text]');
        this.modal = this.querySelector('[data-va-modal]');
        this.panel = this.querySelector('.nn-va-modal__panel');
        this.list = this.querySelector('[data-va-list]');
        this.toast = this.querySelector('[data-va-toast]');
        this.toastIcon = this.querySelector('[data-va-toast-icon]');
        this.toastMessage = this.querySelector('[data-va-toast-message]');
        this.toastTimer = null;
        this.toastHideTimer = null;
        this.lastFocusedElement = null;
        this.handleKeydown = this.onKeydown.bind(this);
        if (!this.trigger || !this.modal || !this.panel || !this.list) return;
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.modal.hidden) this.open(); else this.close();
        });
        this.modal.addEventListener('click', (event) => {
          if (event.target.closest('[data-va-close]')) this.close();
        });
        this.list.addEventListener('click', (event) => this.addToCart(event));
        document.addEventListener('keydown', this.handleKeydown);
        this.load();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.documentElement.classList.remove('nn-va-lock');
        if (this.modal?.dataset.portalized === 'true') this.modal.remove();
      }

      async load() {
        const key = `${this.dataset.apiVersion}:${this.dataset.vaValue}`;
        if (!cache.has(key)) cache.set(key, this.fetchProducts());
        try {
          this.render(await cache.get(key));
        } catch (error) {
          console.warn('VA-Rendering Fehler:', error);
          this.hidden = true;
        }
      }

      async fetchProducts() {
        const products = [];
        let cursor = null;
        const endpoint = `${window.Shopify?.routes?.root || '/'}api/${this.dataset.apiVersion}/graphql.json`;
        const tag = this.dataset.vaValue.replaceAll("'", "\\'");

        do {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.dataset.storefrontAccessToken
            },
            body: JSON.stringify({
              query,
              variables: { query: `tag:'VA_${tag}'`, cursor }
            })
          });

          if (!response.ok) throw new Error(`Storefront API Fehler ${response.status}`);

          const json = await response.json();
          const connection = json.data?.products;
          if (json.errors || !connection) throw new Error('Ungültige Storefront-API-Antwort');

          products.push(...connection.edges.map((edge) => edge.node));
          cursor = connection.pageInfo.hasNextPage ? connection.edges.at(-1)?.cursor : null;
        } while (cursor);

        return products;
      }

      render(products) {
        if (!Array.isArray(products) || !products.length) return;

        const currentProductId = String(this.dataset.productId);
        const filtered = products.filter((product) => numericId(product.id) !== currentProductId);
        if (!filtered.length) return;

        const available = filtered.filter((product) => product.availableForSale);
        const soldOut = filtered.filter((product) => !product.availableForSale);
        const ordered = [...available, ...soldOut];

        this.hidden = false;
        if (this.dataset.displayMode === 'image_grid' && this.imageView && this.imageGrid) {
          this.imageGrid.innerHTML = ordered.map((product) => this.renderImageCard(product)).join('');
          this.imageView.hidden = false;
          return;
        }
        this.triggerText.textContent = `Weitere Sorten anzeigen (${ordered.length})`;
        this.renderPreviews(ordered);
        this.list.innerHTML = ordered.map((product) => this.renderRow(product)).join('');
      }

      renderImageCard(product) {
        const root = window.Shopify?.routes?.root || '/';
        const href = `${root}products/${encodeURIComponent(product.handle)}`;
        const imageUrl = product.featuredImage?.url;
        const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="" loading="lazy" width="400" height="400">` : '<span class="nn-va-image-card__stock">Kein Produktbild</span>';
        const title = product.shortTitle?.value?.trim() || (product.title || '').trim();
        const soldOut = product.availableForSale ? '' : '<span class="nn-va-image-card__sold-out"><span>Ausverkauft</span></span>';
        return `<a class="nn-va-image-card${product.availableForSale ? '' : ' nn-va-image-card--sold-out'}" href="${escapeHtml(href)}" title="${escapeHtml(product.title)}"><span class="nn-va-image-card__picture">${image}${soldOut}</span><span class="nn-va-image-card__name">${escapeHtml(title)}</span></a>`;
      }

      renderPreviews(products) {
        if (!this.previews || products.length < 2) {
          if (this.previews) {
            this.previews.innerHTML = '';
            this.previews.style.display = 'none';
          }
          return;
        }

        const previewProducts = products.filter((product) => product.featuredImage?.url).slice(0, 3);
        if (!previewProducts.length) {
          this.previews.innerHTML = '';
          this.previews.style.display = 'none';
          return;
        }

        this.previews.style.display = 'inline-flex';
        this.previews.innerHTML = previewProducts.map((product, index) => {
          const soldClass = product.availableForSale ? '' : ' is-sold';
          return `<span class="nn-va-preview${soldClass}" style="--i:${index}"><img src="${product.featuredImage.url}" alt="${escapeHtml(product.featuredImage.altText || product.title)}" loading="lazy"></span>`;
        }).join('');
      }

      renderRow(product) {
        const variant = product.variants?.nodes?.find((item) => item.availableForSale) || product.variants?.nodes?.[0];
        const variantId = numericId(variant?.id);
        const priceAmount = variant?.price?.amount;
        const compareAtAmount = variant?.compareAtPrice?.amount;
        const priceCents = Math.round(Number(priceAmount || 0) * 100);
        const compareAtPriceCents = Math.round(Number(compareAtAmount || 0) * 100);
        const price = variant?.price ? this.formatPrice(priceAmount, variant.price.currencyCode) : '';
        const compareAt = variant?.compareAtPrice ? this.formatPrice(compareAtAmount, variant.compareAtPrice.currencyCode) : '';
        const canPreviewDiscount = Boolean(product.availableForSale) && Boolean(variant?.availableForSale);
        const hasCompare = canPreviewDiscount && Boolean(compareAt) && compareAt !== price;
        const canAdd = Boolean(variantId) && Boolean(variant?.availableForSale);
        const imageUrl = product.featuredImage?.url;
        const imageAlt = product.featuredImage?.altText || product.title || '';

        return `<div class="nn-va-row ${product.availableForSale ? '' : 'is-sold'}" data-row><a class="nn-va-row__link" href="/products/${encodeURIComponent(product.handle)}"><div class="nn-va-row__img">${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(imageAlt)}" loading="lazy">` : ''}${product.availableForSale ? '' : '<span class="nn-va-row__badge">Ausverkauft</span>'}</div><div class="nn-va-row__content"><div class="nn-va-row__title">${escapeHtml((product.title || '').trim())}</div>${price ? `<div class="nn-va-row__price"${canPreviewDiscount ? ` data-nn-discount-price-list data-nn-preview-variant-id="${escapeHtml(variantId)}" data-nn-price-cents="${priceCents}" data-nn-compare-at-price-cents="${compareAtPriceCents}"` : ''}>${hasCompare ? `<span class="nn-va-row__compare" data-nn-compare-price>${escapeHtml(compareAt)}</span>` : ''}<span class="nn-va-row__current" data-nn-sale-price>${escapeHtml(price)}</span></div>` : ''}</div></a><button type="button" class="nn-va-atc" data-va-atc data-variant-id="${escapeHtml(variantId)}" ${canAdd ? '' : 'disabled'} aria-label="In den Warenkorb" title="In den Warenkorb">+</button></div>`;
      }

      formatPrice(amount, currencyCode) {
        const value = Number(amount || 0);
        try {
          return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: currencyCode || 'EUR'
          }).format(value);
        } catch {
          return `${(Math.round(value * 100) / 100).toFixed(2).replace('.', ',')} €`;
        }
      }

      ensurePortal() {
        if (this.modal.dataset.portalized === 'true') return;
        document.body.appendChild(this.modal);
        this.modal.dataset.portalized = 'true';
      }

      open() {
        this.ensurePortal();
        this.lastFocusedElement = document.activeElement;
        this.modal.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          this.modal.classList.add('is-open');
          const focusable = this.focusableElements();
          if (focusable.length) focusable[0].focus(); else this.panel.focus();
        });
        document.documentElement.classList.add('nn-va-lock');
      }

      close() {
        this.modal.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('nn-va-lock');
        window.setTimeout(() => {
          this.modal.hidden = true;
          if (this.lastFocusedElement?.focus) this.lastFocusedElement.focus(); else this.trigger.focus();
        }, 220);
      }

      focusableElements() {
        return Array.from(this.panel.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);
      }

      onKeydown(event) {
        if (!this.modal || this.modal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = this.focusableElements();
        if (!focusable.length) {
          event.preventDefault();
          this.panel.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      async addToCart(event) {
        const button = event.target.closest('[data-va-atc]');
        if (!button || button.disabled) return;

        event.preventDefault();
        event.stopPropagation();
        button.disabled = true;
        button.classList.add('is-loading');

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(button.dataset.variantId),
                quantity: 1,
                properties: { Quelle: 'VA' }
              }]
            })
          });

          if (!response.ok) {
            const responseBody = await response.json().catch(() => ({}));
            throw new Error(responseBody.description || this.dataset.errorMessage);
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          button.classList.remove('is-loading');
          button.classList.add('is-done');
          button.textContent = '✓';
          this.showToast(this.dataset.successMessage);

          window.setTimeout(() => {
            button.textContent = '+';
            button.classList.remove('is-done');
            button.disabled = false;
          }, 900);
        } catch (error) {
          console.warn('VA ATC Error:', error);
          button.classList.remove('is-loading');
          button.disabled = false;
          this.showToast(error.message || this.dataset.errorMessage, true);
        }
      }

      showToast(message, isError = false) {
        if (!this.toast || !this.toastMessage) return;

        window.clearTimeout(this.toastTimer);
        window.clearTimeout(this.toastHideTimer);
        this.toast.classList.remove('is-visible');
        this.toast.classList.toggle('is-error', isError);
        this.toast.setAttribute('role', isError ? 'alert' : 'status');
        this.toastMessage.textContent = message || this.dataset.errorMessage;
        if (this.toastIcon) this.toastIcon.textContent = isError ? '!' : '✓';
        this.toast.hidden = false;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.toast.classList.add('is-visible'));
        });

        this.toastTimer = window.setTimeout(() => {
          this.toast.classList.remove('is-visible');
          this.toastHideTimer = window.setTimeout(() => {
            this.toast.hidden = true;
          }, 240);
        }, 2800);
      }
    }

    if (!customElements.get('nn-related-variants')) {
      customElements.define('nn-related-variants', RelatedVariants);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
